

import {Vue, Component, Prop} from "vue-property-decorator";
import TeacherIcon from "src/modules/teacher/TeacherIcon.vue";
import {isInMobileApp} from "src/utils/MobileUtils";
import { getAssetItem } from "src/utils/helpers";

@Component({
  components: {TeacherIcon},
  methods: {getAssetItem}
  })
export default class OnboardingSlide extends Vue {
  @Prop({default: 'onboarding/welcome.webp'}) imageUrl!: string;
  @Prop({default: false}) noBackButton!: boolean;
  @Prop({default: false}) hideTeacher!: boolean;
  previousStatusBarColor: string = '';

  async mounted() {
    if (isInMobileApp() && this.$q.platform.is.capacitor) {
      this.previousStatusBarColor = await this.MobileScreen.getStatusBarColor();
      this.MobileScreen.setNavigationBarColor('primary');
      this.MobileScreen.setStatusBarStyle('primary');
    }
  }

  beforeDestroy() {
    if (isInMobileApp() && this.$q.platform.is.capacitor) {
      this.MobileScreen.setNavigationBarColor('white');
      this.MobileScreen.setStatusBarStyle(this.previousStatusBarColor === '#FFFFFF' ? 'white' : 'primary');
    }
  }
}
